import type { RailwayRunner } from '@cli-types/next-adapter/railway.js'
import { RAILWAY_CLI_VERSION } from '@cli-constants/tool-versions.js'
import { parseVersion } from '@cli-utils/version.js'
import { isCompatibleRailwayVersion } from './is-compatible-railway-version.js'
import { npxRunner } from './npx-runner.js'
import { pathRunner } from './path-runner.js'
import { runRailway } from './run-railway.js'

export async function resolveRailwayRunner(): Promise<RailwayRunner> {
  const probeRunner = pathRunner(RAILWAY_CLI_VERSION)
  const probe = await runRailway(probeRunner, ['--version'], {
    cwd: process.cwd(),
    mode: 'capture',
    timeoutMs: 10_000
  })
  const version = parseVersion(`${probe.stdout}\n${probe.stderr}`)

  return probe.success && version && isCompatibleRailwayVersion(version)
    ? pathRunner(version)
    : npxRunner()
}
